import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlMatcher } from '@angular/router';
import { ExperiencesFeatureGuard } from './core/guards/experiences-feature.guard';
import { LanguageRouteGuard } from './core/guards/language-route.guard';

const mapRouteMatcher: UrlMatcher = (segments) => {
  if (segments.length === 1 && segments[0].path === 'map') {
    return { consumed: segments };
  }

  if (
    segments.length === 3 &&
    segments[0].path === 'map' &&
    (segments[1].path === 'winery' || segments[1].path === 'landmark' || segments[1].path === 'route') &&
    segments[2].path.length > 0
  ) {
    return {
      consumed: segments,
      posParams: {
        itemType: segments[1],
        itemSlug: segments[2]
      }
    };
  }

  return null;
};

const localizedRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./features/home/home.component').then(m => m.HomeComponent),
    data: { seo: { titleKey: 'seo.home.title', descriptionKey: 'seo.home.description' } }
  },
  {
    path: 'get-app',
    loadComponent: () => import('./features/app-download/app-download.component').then(m => m.AppDownloadComponent),
    data: { seo: { titleKey: 'seo.getApp.title', descriptionKey: 'seo.getApp.description', robots: 'noindex, follow' } }
  },
  {
    path: '',
    loadComponent: () => import('./layout/app-shell.component').then(m => m.AppShellComponent),
    children: [
      {
        matcher: mapRouteMatcher,
        loadComponent: () => import('./features/map/map.component').then(m => m.MapComponent),
        data: { seo: { titleKey: 'seo.map.title', descriptionKey: 'seo.map.description' } }
      },
      {
        path: 'houses',
        loadComponent: () => import('./features/houses/houses.component').then(m => m.HousesComponent),
        data: { seo: { titleKey: 'seo.houses.title', descriptionKey: 'seo.houses.description' } }
      },
      {
        path: 'experiences',
        canActivate: [ExperiencesFeatureGuard],
        loadComponent: () => import('./features/experiences/experiences.component').then(m => m.ExperiencesComponent),
        data: { seo: { titleKey: 'seo.experiences.title', descriptionKey: 'seo.experiences.description' } }
      },
      {
        path: 'guides',
        loadComponent: () => import('./features/guides/guides-index.component').then(m => m.GuidesIndexComponent),
        data: { seo: { titleKey: 'seo.guides.title', descriptionKey: 'seo.guides.description' } }
      },
      {
        path: 'guides/:guideSlug',
        loadComponent: () => import('./features/guides/guide-detail.component').then(m => m.GuideDetailComponent),
        data: { seo: { titleKey: 'seo.guides.title', descriptionKey: 'seo.guides.description' } }
      },
      {
        path: 'house/:winerySlug/wines/:wineSlug',
        loadComponent: () => import('./features/house/house.component').then(m => m.HouseComponent),
        data: { seo: { titleKey: 'seo.map.title', descriptionKey: 'seo.map.description' } }
      },
      {
        path: 'house/:winerySlug/experience/:experienceSlug',
        canActivate: [ExperiencesFeatureGuard],
        loadComponent: () =>
          import('./features/experience-detail/experience-detail.component').then(m => m.ExperienceDetailComponent),
        data: { seo: { titleKey: 'seo.map.title', descriptionKey: 'seo.map.description' } }
      },
      {
        path: 'house/:winerySlug',
        loadComponent: () => import('./features/house/house.component').then(m => m.HouseComponent),
        data: { seo: { titleKey: 'seo.map.title', descriptionKey: 'seo.map.description' } }
      },
      {
        path: 'landmark/:landmarkSlug',
        loadComponent: () => import('./features/landmark/landmark.component').then(m => m.LandmarkComponent),
        data: { seo: { titleKey: 'seo.map.title', descriptionKey: 'seo.map.description' } }
      },
      {
        path: 'favorites',
        loadComponent: () => import('./features/favorites/favorites.component').then(m => m.FavoritesComponent),
        data: { seo: { titleKey: 'seo.favorites.title', descriptionKey: 'seo.favorites.description', robots: 'noindex, follow' } }
      },
      {
        path: 'activity',
        loadComponent: () => import('./features/activity/activity.component').then(m => m.ActivityComponent),
        data: { seo: { titleKey: 'seo.activity.title', descriptionKey: 'seo.activity.description', robots: 'noindex, follow' } }
      },
      {
        path: 'profile',
        loadComponent: () => import('./features/profile/profile.component').then(m => m.ProfileComponent),
        data: { seo: { titleKey: 'seo.profile.title', descriptionKey: 'seo.profile.description', robots: 'noindex, follow' } }
      }
    ]
  },
  { path: '**', redirectTo: '' }
];

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [LanguageRouteGuard],
    children: []
  },
  {
    path: ':lang',
    canActivate: [LanguageRouteGuard],
    canActivateChild: [LanguageRouteGuard],
    children: localizedRoutes
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
